// Constants for search listing functionality

export const DEFAULT_ARRIVAL_DATE = "anyArrival";
export const DEFAULT_DEPARTURE_DATE = "anyDeparture";

export const SEARCH_HISTORY_STORAGE_KEY = 'anystay_search_history';
export const MAX_SEARCH_HISTORY_ENTRIES = 50;
